import { Chip, Stack } from "@mui/material";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	templates: ReminderTemplate[];
	selectedTypeKey: string;
	onSelect: (template: ReminderTemplate) => void;
};

export const ReminderTemplateChips = ({
	templates,
	selectedTypeKey,
	onSelect,
}: Props) => {
	const { t } = useResource();

	if (
		templates.length === 0 ||
		templates.every((template) => template.isCustom)
	) {
		return null;
	}

	return (
		<Stack
			direction="row"
			gap={1}
			px={1.6}
			py={1.2}
			sx={{
				overflowX: "auto",
				flexWrap: "nowrap",
			}}
		>
			{templates.map((template) => (
				<Chip
					key={template.typeKey}
					variant="tag"
					color={selectedTypeKey === template.typeKey ? "info" : "default"}
					label={template.labelKey ? t(template.labelKey) : template.typeKey}
					onClick={() => onSelect(template)}
					sx={{ flexShrink: 0 }}
				/>
			))}
		</Stack>
	);
};
